module.exports = __webpack_public_path__ + "70171c4062d1da7e0067bd19f6d1f91b.svg";